export const painPoints = [
  {
    emoji: '🧭',
    title: 'You don’t know where to start',
    desc: 'The blank page becomes overwhelming. THE AI BOOK BUILDER™ gives you a structured process to transform your raw idea into a clear book blueprint.',
  },
  {
    emoji: '🧩',
    title: 'Your characters feel flat',
    desc: 'You know who they are… but you don’t fully understand their motivations, fears, conflicts and emotional journeys. Use structured AI prompts to develop deeper, more consistent characters.',
  },
  {
    emoji: '📝',
    title: 'You struggle to turn ideas into chapters',
    desc: 'You may have the concept, even the outline. But actually writing the scenes is where momentum disappears. The Manuscript Engine helps you move from outline → scenes → chapters.',
  },
  {
    emoji: '💬',
    title: 'Your writing sounds generic',
    desc: 'AI can generate words. But good writing requires voice, emotion, rhythm and storytelling. Use structured prompts to improve dialogue, descriptions, narrative voice and emotional impact.',
  },
  {
    emoji: '🎯',
    title: 'You keep starting — but never finishing',
    desc: 'You don’t need another unfinished document sitting on your computer. You need a process that tells you what to work on next.',
  },
];
